<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none" class="icon">
    <path d="M24.5125 33.2457L33.6205 28L24.5125 22.7543V33.2457Z" fill="currentColor" />
    <path
      d="M28 0C12.5384 0 0 12.5384 0 28C0 43.4616 12.5384 56 28 56C43.4616 56 56 43.4616 56 28C56 12.5384 43.4616 0 28 0ZM45.4957 28.0286C45.4957 28.0286 45.4957 33.7072 44.7754 36.4454C44.3716 37.9442 43.1899 39.1259 41.6911 39.5292C38.9529 40.25 28 40.25 28 40.25C28 40.25 17.0757 40.25 14.3089 39.5006C12.8101 39.0973 11.6284 37.9151 11.2246 36.4163C10.5038 33.7072 10.5038 28 10.5038 28C10.5038 28 10.5038 22.3219 11.2246 19.5837C11.6279 18.0849 12.8387 16.8741 14.3089 16.4708C17.0471 15.75 28 15.75 28 15.75C28 15.75 38.9529 15.75 41.6911 16.4994C43.1899 16.9027 44.3716 18.0849 44.7754 19.5837C45.5248 22.3219 45.4957 28.0286 45.4957 28.0286Z"
      fill="currentColor"
    />
  </svg>
</template>

<style lang="scss" scoped>
.icon {
  transition: color 0.3s;

  @media (hover: hover) {
    &:hover {
      color: #FF0033;
    }
  }

  @media (hover: none) {
    &:active {
      color: #FF0033;
    }
  }
}
</style>
